import React from 'react';
import AdditionalColumnsNumber
    from '@src/components/_views/configurable/import-view/file-list/additional-row/fields/AdditionalColumnsNumber';
import SkipFirstRows
    from '@src/components/_views/configurable/import-view/file-list/additional-row/fields/SkipFirstRows';
import HasHeader from '@src/components/_views/configurable/import-view/file-list/additional-row/fields/HasHeader';

export default function ImportSettings() {
    const colClassName = 'col-sm-12 col-md-4 mb-3';

    return <div className="row">
        <div className={colClassName}>
            <HasHeader/>
        </div>
        <div className={colClassName}>
            <SkipFirstRows/>
        </div>
        <div className={colClassName}>
            <AdditionalColumnsNumber/>
        </div>
    </div>;
}
